module.exports = __webpack_public_path__ + "img/bnr_camplist@2x.c87d7181.png";